/**
 * Project: Gus's Auto Dealership
 * Author: Eihab Khudhair
 * Description: Client-side layout wrapper with admin shortcut
 */

'use client';

import { useAdminShortcut } from '@/lib/useAdminShortcut';
import Navbar from './Navbar';
import Footer from './Footer';
import { usePathname } from 'next/navigation';

export default function ClientLayout({ children }: { children: React.ReactNode }) {
  useAdminShortcut();
  const pathname = usePathname();
  
  // Don't show navbar/footer on admin pages
  const isAdminPage = pathname?.startsWith('/admin');

  if (isAdminPage) {
    return <>{children}</>;
  }

  return (
    <>
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
    </>
  );
}
